import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { useSelector } from "react-redux"
import { RootState } from "../../app/store"

interface IRouterState {
    prevPage: string | null,
    currentPage: string | null,
    darkMode: boolean
}

const initialState: IRouterState = {
    prevPage: null,
    currentPage: null,
    darkMode: true
}

const routerSlice = createSlice({
    name: "router",
    initialState,
    reducers: {
        updateRouterPrevPage: (state: IRouterState, action: PayloadAction<string | null>) => {
            state.prevPage = action.payload
        },
        updateNavigationState: (state: IRouterState, action: PayloadAction<string | null>) => {
            state.prevPage = state.currentPage
            state.currentPage = action.payload
        },
        updateDarkMode: (state: IRouterState, action: PayloadAction<boolean>) => {
            state.darkMode = action.payload
        },
    }
})

/**
 * Use return router prev page
 */
export const useReturnRouterPrevPage = () => useSelector((state: RootState) => state.router.prevPage)

/**
 * Use return router current page
 */
export const useReturnRouterCurrentPage = () => useSelector((state: RootState) => state.router.currentPage)

/**
 * Use return dark mode status
 */
export const useReturnDarkModeStatus = () => useSelector((state: RootState) => state.router.darkMode)

export const { updateRouterPrevPage, updateNavigationState, updateDarkMode } = routerSlice.actions
export default routerSlice.reducer